import ValidationErrors from 'fou-myfonts-validations/error-keys'
import Countries from './countries'
import States from './states'
import OTFeatures from './ot_features'

const VALIDATION_ERRORS = Array.from(new Set(ValidationErrors.keys))
const COUNTRIES = Countries.keys
const STATES = States
const OTFEATURES = OTFeatures.keys

export default {
  VALIDATION_ERRORS,
  COUNTRIES,
  STATES,
  OTFEATURES
}
